import React from 'react';
import Immutable from 'immutable';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { MESSAGE_TEMPLATE_BADGE } from '../../../config/constants';
import formatDate from '../../../helpers/formatDate';
import useClasses from '../../../hooks/useClasses';
import useRoutes from '../../../hooks/useRoutes';
import { ImmutableMessageEntity } from '../../../implementations/View';
import Badge from '../../Badge';
import CoreLink from '../../CoreLink';
import Icon from '../../Icon';

import './style.scss';

interface Props {
  entity: ImmutableMessageEntity;
  onClick: () => void;
}

const MessageTeaser: React.FC<Props> = ({ entity, onClick }) => {
  const { account } = useRoutes();
  const { buildClass } = useClasses('MessageTeaser');

  const template = entity.getIn(['template', 0, 'target_id'], '');
  const created = entity.getIn(['created', 0, 'value'], '');
  const title = entity.getIn(['text', 0, 'value', 0], '');
  const badge = entity.getIn(['field_badge', 0, 'entity'], Immutable.Map());

  return (
    <li className={buildClass()}>
      <CoreLink to={account.messages} onClick={onClick}>
        <div className={buildClass('icon-container')}>
          {template === MESSAGE_TEMPLATE_BADGE ? (
            <Badge image={badge.getIn(['field_image', 0, 'entity', 'field_media_file', 0], Immutable.Map())} />
          ) : (
            <Icon icon="bell" variant="0" size="md" />
          )}
        </div>

        <div className={buildClass('content')}>
          <div className={buildClass('text')}>
            <h2 className="asH4">
              <WysiwygField
                property="schema:text"
                html={title}
              />
            </h2>
          </div>

          <div className={buildClass('date')}>
            <span className="body--tiny">{formatDate(created, 'DD MMM YYYY')}</span>
          </div>
        </div>
      </CoreLink>
    </li>
  );
};

export default MessageTeaser;
